import _extends from "@babel/runtime-corejs3/helpers/extends";
import { createUnknownComponentVNode as _$cc, createElementVNode as _$ce, noop as _$no, className as _$cn } from 'intact-vue-next';
import { Transition } from 'intact-vue-next';
import { makeMenuStyles } from './styles';
export default function ($props, $blocks, $__proto__) {
  var _classNameObj;
  $blocks || ($blocks = {});
  $props || ($props = {});
  var $this = this;
  var _$blocks = {};
  var __$blocks = {};
  var _this$dropdown$get = this.dropdown.get(),
    value = _this$dropdown$get.value,
    trigger = _this$dropdown$get.trigger,
    container = _this$dropdown$get.container;
  var _this$get = this.get(),
    children = _this$get.children,
    className = _this$get.className;
  var k = this.config.k;
  var classNameObj = (_classNameObj = {}, _classNameObj[k + "-dropdown-menu"] = true, _classNameObj[className] = className, _classNameObj[$props.className] = $props.className, _classNameObj[makeMenuStyles(k)] = true, _classNameObj);
  var transition = $props.transition || _extends({
    css: false
  }, this.transition);
  return _$cc(Transition, _extends({
    'show': 'value' in $props ? $props.value : !!value,
    'appear': true
  }, transition, {
    'children': _$ce(2, 'div', (_$blocks['children'] = function ($super) {
      return children;
    }, __$blocks['children'] = function ($super, data) {
      var block = $blocks['children'];
      var callBlock = function callBlock() {
        return _$blocks['children'].call($this, $super, data);
      };
      return block ? block.call($this, callBlock, data) : callBlock();
    }, __$blocks['children'](_$no)), 0, _$cn(classNameObj), {
      'ev-mouseenter': this.onMouseEnter,
      'ev-mouseleave': trigger === 'hover' ? this.onMouseLeave : null
    }, null, this.elementRef)
  }));
}
;